import { Component, OnInit } from "@angular/core"
import { KapraoService } from "../../../services/kaprao.service"
import { MessageService } from "../../../services/login.service"
import { ActivatedRoute } from "@angular/router"

@Component({
    selector: "app-print-page",
    templateUrl: "./print-page.component.html",
    styleUrls: ["./print-page.component.scss"],
})
export class PrintPageComponent implements OnInit {
    pData
    subscription
    printData
    constructor(
        private service: KapraoService,
        private messageService: MessageService,
        private route: ActivatedRoute
    ) {}

    ngOnInit(): void {
        this.pData = JSON.parse(this.route.snapshot.paramMap.get("printData"))
        setTimeout(function () {
            window.print()
        }, 500)
        window.onfocus = function () {
            setTimeout(function () {
                window.close()
            }, 100)
        }

        console.log(this.printData)
        this.messageService.sendMessage("print")
    }
}
